import React from "react";
import logo from "../Icons/Branding/logo.svg";

import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles((theme: Theme) => ({
  image: {
    height: "200px",
    width: "200px",
    cursor: "pointer",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
}));

const Logo = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Box className={classes.logoContainer}>
      <img
        src={logo}
        alt="logo"
        className={classes.image}
        onClick={() => navigate("/pricelist")}
      />
    </Box>
  );
};

export default Logo;
